import * as BasicScroll from 'basicscroll'
import {
    Controller
} from "stimulus"

export default class extends Controller
{
    basicScroll = null

    get defaults()
    {

        let props = {}

        props[this.data.has('name') ? `--${this.data.get('name')}` : '--translate-y'] = {
            from: this.data.has('from') ? this.data.get('from') : '0px',
            to: this.data.has('to') ? this.data.get('to') : '-100px'
        }

        return Object.assign({
            elem: this.element,
            from: 'top-bottom',
            to: 'bottom-top',
            direct: this.data.get('direct') === 'true',
            props: props
        }, {})
    }

    get config()
    {
        let config = JSON.parse(this.data.get('config'))

        if (!config) {
            return this.defaults
        }

        return Object.assign(this.defaults, config)
    }

    initialize()
    {
        this.start()
    }

    start()
    {
        this.basicScroll = BasicScroll.create(this.config)
        this.basicScroll.start()
    }

    stop()
    {
        this.basicScroll.destroy()
    }

    disconnect()
    {
        this.stop()
    }
}
